import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { GlassCard } from '../components/ui';
import { ShipRequestForm } from '../components/forms/ShipRequestForm';
import { RecentShipments } from '../components/forms/RecentShipments';

export function ShipRequestFormPage() {
  return (
    <div className="min-h-screen flex flex-col w-full min-w-0">
      <Header showBackButton backHref="/portal" />

      <main className="flex-1 w-full min-w-0 container mx-auto px-4 py-8 pb-16 max-w-6xl">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Request to Ship
          </h1>
          <p className="text-gray-600">
            Submit a shipping request to the NJ Warehouse. Fill out the recipient
            details and shipping preferences below.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 items-start">
          {/* ── Form ──────────────────────────────────────────────────── */}
          <div className="lg:col-span-3">
            <GlassCard className="p-6 md:p-8" hoverable={false}>
              <ShipRequestForm />
            </GlassCard>
          </div>

          {/* ── Recent Shipments ──────────────────────────────────────── */}
          <div className="lg:col-span-2">
            <GlassCard className="p-5" hoverable={false}>
              <RecentShipments />
            </GlassCard>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
